var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import MultiSelectFilterOption from "./MultiSelectFilterOption";
var MultiSelectFilterOptGroup = function (_a) {
    var label = _a.label, options = _a.options, disabled = _a.disabled;
    return (React.createElement("li", { className: "ssg-multi-select-filter__option-checkbox-group", "aria-disabled": disabled !== null && disabled !== void 0 ? disabled : false },
        label,
        React.createElement("ul", null, options.map(function (option) { return (React.createElement(MultiSelectFilterOption, __assign({ key: option.value + option.name }, option))); }))));
};
export default MultiSelectFilterOptGroup;
